'use client'

import { Box, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import React from 'react'

const RefundInfo: React.FC = () => {
    const t = useTranslations('srpFlightDetails')

    return (
        <Box
            sx={{
                backgroundColor: '#FFF',
                display: 'flex',
                borderTop: '1px solid',
                borderColor: 'grey.200'
            }}
        >
            <Box
                sx={{
                    py: 2,
                    pl: 2,
                    pr: 1,
                    flex: 1,
                    borderRight: '1px solid',
                    borderColor: 'grey.200'
                }}
            >
                <Typography sx={{ fontWeight: 600, fontSize: { sm: 14, md: 16 } }}>
                    {' '}
                    {t('standardFarePerTraveler')}
                </Typography>
            </Box>

            <Box sx={{ flex: 2, p: 2 }}>
                <Typography sx={{ fontSize: { sm: 12, md: 14 } }}> {t('nonRefundableInfo')}</Typography>
            </Box>
        </Box>
    )
}

export default RefundInfo
